// myPermitsComponent
const initialState = {
  documentImage: [],
  rightValue: 0,
  activeTab: 0,
  selectedRow: null,
  selectedPermitType: "",
  commonValues: [],
  prevRowID: true,
  leftValue: 0,
  instructionDownloading: false,
  attachingNewPermit: {
    started: false,
    taskId: "",
    form: {},
    county: "",
    city: "",
    addedPermits: [],
    additionalPermits: {},
    usedContractors: [],
    packageSnapshot: null,
    prevPermitGrid: {
      page: 0,
      pageSize: 5,
      rowCount: 0,
    },
  },
  realEstate: {
    fetchLoading: false,
    presetLoading: false,
    addressOptions: [],
    selectedAddress: "",
    selectedAddressTemp: "",
    selectedAddressTempObj: null,
    selectedAddressShort: "",
  },
  citySite: {
    cityPermitLoading: false,
    fullPermitMap: [],
    typeSelections: null,
    permitPanelOpen: false,
    jaxFields: null,
    jaxDocs: null,
    viewDocLoading: null,
    jaxFieldsFetchError: null,
    jaxFieldsLoading: false,
    createScheduleLoading: false,
  },
  sovTemplates: [],
  usingTemplate: {
    isUsingTemplate: false,
    templateID: "",
    templateName: "",
    removedTemplate: false,
  },
  scheduleOfValues: {
    rows: [],
    scheduleCreated: false,
    remainingAmount: "―",
    remainingPercentage: "―",
    totalCost: 0,
    totalCostDisplay: "",
    editSchedule: false,
    scheduleOfValuesDocLoading: false,
    loadedLogo: "",
    downloadLoading: false,
    savingTemplateLoading: false,
  },
  duvalMap: {
    mapSatellite: false,
    showMap: false,
    mapType: "streets-navigation-vector",
    noMapAddressError: false,
  },
  permits: {
    creatingDocTitle: "",
    numCreated: 0,
    changePackageNameLoading: false,
    myPermitsSnackOpen: false,
    myPermitsSnackText: "",
    loadings: {
      dataLoading: false,
      activeTabLoading: false,
      cancelPermitLoading: false,
      createLoading: false,
      paymentLoading: false,
      downloading: false,
      ppDownloading: false,
      tempLoading: false,
      uploadDocLoading: false,
    },
    modalStates: {
      permitDrawerOpen: false,
      promoModalOpen: false,
      paymentModalOpen: false,
      addPaymentModal: false,
      addPaymentModalOpen: false,
    },
    pagination: {
      page: 0,
      pageSize: 5,
      rowCount: 0,
    },
  },
  cityFailedErrorText: "",
  currentPopup: "pop1",
  cityPermitButtonDisabled: false,
};

const myPermitsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ATTACHING_NEW_PERMIT":
      return {
        ...state,
        attachingNewPermit: {
          ...state.attachingNewPermit,
          ...action.payload,
        },
      };
    case "SET_CITY_PERMIT_BUTTON_DISABLED":
      return {
        ...state,
        cityPermitButtonDisabled: action.payload,
      };
    case "FILL_COMMON_VALUES": {
      return {
        ...state,
        commonValues: state.selectedRow?.common_fields || [],
      };
    }
    case "REVERT_COMMON_VALUES": {
      const updates = new Map(
        action.payload.map((u) => [u.common_name, u.value])
      );
      return {
        ...state,
        commonValues: state.commonValues.map((item) =>
          updates.has(item.common_name)
            ? { ...item, value: updates.get(item.common_name) }
            : item
        ),
      };
    }
    case "UPDATE_COMMON_VALUE": {
      const { common_name, value } = action.payload;
      return {
        ...state,
        commonValues: state.commonValues.map((item) =>
          item.common_name === common_name ? { ...item, value } : item
        ),
      };
    }

    case "UPDATE_JAX_DOC":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          jaxDocs: state.citySite.jaxDocs.map((doc) =>
            doc.docTypeId === action.payload.docTypeId ? action.payload : doc
          ),
        },
      };
    case "REMOVE_SOV_TEMPLATE":
      return {
        ...state,
        sovTemplates: state.sovTemplates.filter(
          (template) => template.id !== action.payload
        ),
      };

    case "PUSH_SOV_TEMPLATE":
      const incoming = action.payload;
      const existingIndex = state.sovTemplates.findIndex(
        (tpl) => tpl.template_name === incoming.template_name
      );

      if (existingIndex !== -1) {
        // Update the existing template
        const updatedTemplates = [...state.sovTemplates];
        updatedTemplates[existingIndex] = {
          ...updatedTemplates[existingIndex],
          ...incoming, // merge new keys/values in
        };

        return {
          ...state,
          sovTemplates: updatedTemplates,
        };
      } else {
        // Push new template
        return {
          ...state,
          sovTemplates: [...state.sovTemplates, incoming],
        };
      }

    case "INIT_SOV_TEMPLATE":
      return {
        ...state,
        sovTemplates: action.payload,
      };
    case "SET_VIEW_DOC_LOADING":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          viewDocLoading: action.payload,
        },
      };
    case "SET_CREATE_SCHEDULE_LOADING":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          createScheduleLoading: action.payload,
        },
      };
    case "SET_PREV_ROW_ID":
      return {
        ...state,
        prevRowID: action.payload,
      };
    case "SET_JAX_FIELDS_FETCH_ERROR":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          jaxFieldsFetchError: action.payload,
        },
      };
    case "SET_JAX_FIELDS_LOADING":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          jaxFieldsLoading: action.payload,
        },
      };
    case "FILL_JAX_FIELDS":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          jaxFields: action.payload?.data,
          jaxDocs: action.payload?.documents,
        },
      };
    case "SET_PERMIT_PANEL_OPEN":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          permitPanelOpen: action.payload,
        },
      };
    case "CLEAR_REAL_ESTATE":
      return {
        ...state,
        realEstate: initialState.realEstate,
      };
    case "SET_NUM_CREATED":
      return {
        ...state,
        permits: {
          ...state.permits,
          numCreated: action.payload,
        },
      };
    case "SET_CREATING_DOC_TITLE":
      return {
        ...state,
        permits: {
          ...state.permits,
          creatingDocTitle: action.payload,
        },
      };
    case "SET_DOCUMENT_IMAGE":
      return {
        ...state,
        documentImage: action.payload,
      };
    case "SET_PERMIT_LOADINGS":
      return {
        ...state,
        permits: {
          ...state.permits,
          loadings: {
            ...state.permits.loadings,
            ...action.payload,
          },
        },
      };
    case "SET_MODALS_STATE":
      return {
        ...state,
        permits: {
          ...state.permits,
          modalStates: {
            ...state.permits.modalStates,
            ...action.payload,
          },
        },
      };
    case "SET_CURRENT_POPUP":
      return {
        ...state,
        currentPopup: action.payload,
      };
    case "SET_CITY_FAILED_ERROR_TEXT":
      return {
        ...state,
        cityFailedErrorText: action.payload,
      };
    case "SET_PAGE_SIZE":
      return {
        ...state,
        permits: {
          ...state.permits,
          pagination: {
            ...state.permits.pagination,
            pageSize: action.payload,
          },
        },
      };
    case "SET_PAGE":
      return {
        ...state,
        permits: {
          ...state.permits,
          pagination: {
            ...state.permits.pagination,
            page: action.payload,
          },
        },
      };
    case "SET_ROW_COUNT":
      return {
        ...state,
        permits: {
          ...state.permits,
          pagination: {
            ...state.permits.pagination,
            rowCount: action.payload,
          },
        },
      };
    case "SET_MY_PERMITS_SNACK_OPEN":
      return {
        ...state,
        permits: {
          ...state.permits,
          myPermitsSnackOpen: action.payload.isOpen,
          myPermitsSnackText: action.payload.snackText,
        },
      };
    case "SET_CHANGE_PACKAGE_NAME_LOADING":
      return {
        ...state,
        permits: {
          ...state.permits,
          changePackageNameLoading: action.payload,
        },
      };
    case "PRE_SAVE_CITY_SELECTIONS":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          fullPermitMap: action.payload.miniMap,
          typeSelections: action.payload.formSelections,
        },
      };
    case "SET_NO_ADDRESS_ERROR":
      return {
        ...state,
        duvalMap: {
          ...state.duvalMap,
          noMapAddressError: action.payload,
        },
      };

    case "RESOLVE_TEMPLATE_ADDRESS":
      return {
        ...state,
        realEstate: {
          ...state.realEstate,
          selectedAddressTemp: action.payload,
          selectedAddressShort: "",
        },
      };
    case "CLEAR_MY_PERMIT_STATES":
      return initialState;
    case "SET_RIGHT_VALUE":
      return {
        ...state,
        rightValue: action.payload,
      };
    case "SET_ACTIVE_TAB":
      return {
        ...state,
        activeTab: action.payload,
      };
    case "SET_SELECTED_ROW":
      return {
        ...state,
        selectedRow: action.payload,
      };
    case "SET_SELECTED_PERMIT_TYPE":
      return {
        ...state,
        selectedPermitType: action.payload,
      };
    case "SET_LEFT_VALUE":
      return {
        ...state,
        leftValue: action.payload,
      };
    case "SET_INSTRUCTION_DOWNLOADING":
      return {
        ...state,
        instructionDownloading: action.payload,
      };
    //? REAL ESTATE - DUVAL - /////////////////////////////////////
    case "SET_REAL_ESTATE_FETCH_LOADING":
      return {
        ...state,
        realEstate: {
          ...state.realEstate,
          fetchLoading: action.payload,
        },
      };
    case "SET_CITY_PERMIT_LOADING":
      return {
        ...state,
        citySite: {
          ...state.citySite,
          cityPermitLoading: action.payload,
        },
      };
    case "SET_REAL_ESTATE_PRESET_LOADING":
      return {
        ...state,
        realEstate: {
          ...state.realEstate,
          presetLoading: action.payload,
        },
      };
    case "SET_REAL_ESTATE_ADDRESS_OPTIONS":
      return {
        ...state,
        realEstate: {
          ...state.realEstate,
          addressOptions: action.payload,
        },
      };
    case "SET_SELECTED_REAL_ESTATE_ADDRESS":
      return {
        ...state,
        realEstate: {
          ...state.realEstate,
          selectedAddress: action.payload,
        },
      };
    case "SET_SELECTED_REAL_ESTATE_ADDRESS_TEMP":
      return {
        ...state,
        realEstate: {
          ...state.realEstate,
          selectedAddressTemp: action.payload.fullAddress,
          selectedAddressShort: action.payload.shortAddress,
          selectedAddressTempObj: action.payload.selectedAddressTempObj,
        },
      };
    case "HANDLE_SET_MAP_TYPE":
      return {
        ...state,
        duvalMap: {
          ...state.duvalMap,
          mapSatellite: action.payload.mapSatellite,
          mapType: action.payload.mapType,
        },
      };
    case "HANDLE_SET_SHOW_MAP":
      return {
        ...state,
        duvalMap: {
          ...state.duvalMap,
          showMap: action.payload,
        },
      };
    case "SET_RENDER_MAP_INITIALS":
      return {
        ...state,
        duvalMap: {
          ...state.duvalMap,
          showMap: action.payload.showMap,
          mapSatellite: action.payload.mapSatellite,
          mapType: action.payload.mapType,
        },
        realEstate: {
          ...state.realEstate,
          ...(action.payload?.additionClean?.hasOwnProperty("selectedAddress")
            ? { selectedAddress: action.payload.additionClean.selectedAddress }
            : {}),
          addressOptions: action.payload.addressOptions,
          selectedAddressTemp: action.payload.selectedAddressTemp,
          selectedAddressShort: action.payload.selectedAddressShort,
          addressMapClearing: action.payload.addressMapClearing,
        },
      };
    case "SET_REAL_ESTATE_PRESETS_SELECTED_ROW":
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          realEstatePresets: action.payload.data,
        },
        realEstate: {
          ...state.realEstate,
          selectedAddress: action.payload.address,
        },
      };
    case "SET_SCHEDULE_OF_VALUES":
      return {
        ...state,
        scheduleOfValues: {
          ...state.scheduleOfValues,
          ...action.payload,
        },
      };
    case "SET_USING_TEMPLATES":
      return {
        ...state,
        usingTemplate: {
          ...state.usingTemplate,
          ...action.payload,
        },
      };
    case "SET_SOV_TEMPLATES":
      return {
        ...state,
        sovTemplates: action.payload,
      };
    case "UPDATE_SCHEDULE_OF_VALUES_NEED_CREATE":
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          connect_to_city: {
            ...state.selectedRow?.connect_to_city,
            schedule_of_values: {
              ...state.selectedRow?.connect_to_city?.schedule_of_values,
              need_create: action.payload,
            },
          },
        },
      };
    case "UPDATE_JOB_COST":
      return {
        ...state,
        commonValues: state.commonValues.map((item) =>
          item.common_name === "job_cost"
            ? { ...item, value: action.payload }
            : item
        ),
      };
    case "UPDATE_NOC_DOCUMENT":
      return {
        ...state,
        selectedRow: {
          ...state.selectedRow,
          documents: {
            ...state.selectedRow.documents,
            noc: action.payload,
          },
        },
      };

    default:
      return state;
  }
};

export default myPermitsReducer;
